import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ColumnModel, CommandModel } from "@syncfusion/ej2-vue-grids";
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import BaseGridView from "../../common/BaseGridView.Component.vue";
import { SearchOption, TemplateDef } from "../../common/CommonInterfaces";


export default /*@__PURE__*/_defineComponent({
  __name: 'CurrencyComponent',
  setup(__props) {

let columnDef = ref([] as ColumnModel[]);

const _searchOptions = {
  fields: ["company.Name", "code", "notation"],
  operator: "contains",
  ignoreCase: true,
} as SearchOption;

const app = getCurrentInstance();
const templateDef: TemplateDef = {
  prefix: "currency",
  columnNames: ["isActive"],
};
const commands: Array<CommandModel> = [
  {
    title: "View",
    buttonOption: { cssClass: "e-flat", iconCss: "e-eye e-icons" },
  },
];

onBeforeMount(() => {
  assignColumnDef();
});

const assignColumnDef = () => {
  const instance = app?.proxy;

  columnDef.value = [
    {
      field: "companyName",
      headerText: instance?.$t("companyName"),
      textAlign: "Center",
    },
    { field: "code", headerText: instance?.$t("code") },
    {
      field: "isActive",
      headerText: instance?.$t("status"),
      template: "currency_isActive",
    },
    { field: "notation", headerText: instance?.$t("notation") },
  ];
};

const onCommandsClick = (commandTitle: string, rowData: any) => {
  alert(commandTitle);
  console.log(rowData);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseGridView, {
    endpoint: "v1/Currency/GetData",
    pageTitle: _ctx.$t('Currency'),
    columnDef: (_unref(columnDef) as Array<ColumnModel>),
    searchOptions: _searchOptions,
    templateDef: templateDef
  }, {
    currency_isActive: _withCtx(({ rowData }) => [
      _createElementVNode("span", {
        class: _normalizeClass(rowData.value ? 'badge badge-success' : 'badge badge-danger')
      }, _toDisplayString(rowData.value ? "Active" : "Inactive"), 3)
    ]),
    _: 1
  }, 8, ["pageTitle", "columnDef"]))
}
}

})